<template>
  <div>
    <!-- 业务员首页-->
    <baseBreadcrumb :page="$t('message.salesmanIndex')" :menu="$t('message.index')" />
    <div class="body">
      <!-- 跳转 -->
      <searchLink />
      <div class="select">
        {{ $t('message.lastUpdateTime') }} {{ detail.refresh_time }}

      </div>
      <!-- 列表 -->
      <div class="list">
        <div class="row" v-for="(item, index) in tableData" :key="index">
          <div v-for="(type, typeIndex) in item.row" :key="typeIndex">
            <div class="type" v-if="type.list != false" :style="{ borderColor: type.color }">
              <div class="head"> <span :style="{ background: type.color }"></span>
                {{ locale == 'zh' ? type.head : type.head_jp }}
              </div>
              <div class="item" v-for="(items, indexs) in type.list" :key="indexs"
                :style="{ background: type.background }" @click.stop="link(items.link)">
                <div class="num" :style="{ background: type.color }">{{ items.v }}</div>
                <div class="name">
                  {{ items.tag }}
                </div>
                <!-- 紧急 -->
                <div class="exigency" v-if="items.overdue != null" @click.stop="overdueLink(items.link)">{{
                  $t('message.overdue') }} ({{ items.overdue }})</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import searchLink from '../link.vue'
export default {
  components: {
    searchLink
  },
  data() {
    return {
      options: [],
      tableData: [
        {
          row: [
            {
              color: '#FF7364 ',
              background: '#FFEFF0',
              head: '订单待处理',
              head_jp: '注文書処理',
              name: 'order',
              list: [
              ]
            },
            {
              color: '#B882FF ',
              background: '#FFEFFD',
              head: '配送单待处理',
              head_jp: '配送依頼書処理',
              name: 'porder',
              list: [

              ]
            },
          ]
        },
        {
          row: [
            {
              color: '#F6C05D  ',
              background: '#FCF7EA ',
              head: '问题产品',
              head_jp: '問題商品',
              name: 'problem_goods',
              list: [

              ]
            },
            {
              color: '#51ACD6',
              background: '#EBFCFF',
              head: '赔款与售后',
              head_jp: '賠償＆アフターサービス',
              name: 'after_sale_reparation',
              list: [

              ]
            },
            {
              color: '#FF7364',
              background: '#EBFCFF',
              head: '提现待确认',
              head_jp: '提现待确认',
              name: 'clientCashOut',
              list: [

              ]
            },
            {
              color: '#F6C05D',
              background: '#FCF7EA',
              head: '今日收件包裹数',
              head_jp: '今日收件包裹数',
              name: 'pack_check',
              list: [

              ]
            },
            {
              color: '#FF7364',
              background: '#FFEFF0',
              head: '客户评价',
              head_jp: '',
              name: '',
              list: [

              ]
            },
            {
              color: '#F6C05D  ',
              background: '#FCF7EA ',
              head: '客户投诉',
              head_jp: '客户投诉',
              name: 'chat_manage',
              list: [

              ]
            },
          ]
        },
        {
          row: [
            {
              color: '#6FD882 ',
              background: '#ECF9ED ',
              head: '商品跟进',
              head_jp: '商品フォロー',
              name: 'order_detail',
              list: [

              ]
            },
            {
              color: '#7C98FF',
              background: '#F0F5FC',
              head: '装箱单',
              head_jp: '梱包',
              name: 'order_box',
              list: [
              ]
            },
            {
              color: '#FF7364 ',
              background: '#FFEFF0',
              head: '检品单待处理',
              head_jp: '検品',
              name: 'inspect_detail',
              list: [

              ]
            },

            {
              color: '#F6C05D',
              background: '#FCF7EA',
              head: '物流系统',
              head_jp: '今日收件包裹数',
              name: '',
              list: [

              ]
            },
          ]
        },
      ],
      detail: {},
      y_id: JSON.parse(localStorage.getItem('japanUserRoleInfo')).id
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
  },
  created() {
    this.dashboardIndex()
  },
  watch: {
    locale() {
      this.dashboardIndex()
    },
  },
  methods: {
    dashboardIndex() {
      this.$api.dashboardIndex({ lang: this.locale == 'ja' ? 'jp' : '' }).then(res => {
        this.detail = res.data
        this.tableData.forEach(item => {
          item.row.forEach(items => {
            for (let key in res.data.list) {
              if (items.name == key) {
                items.list = res.data.list[key]
              }
            }
          })
        })
        // console.log(res.data.list);
      })

      this.$api.abnormalParcelStatistics({ y_id: this.y_id }).then(res => {
        this.tableData[2].row[3].list.push(
          {
            "tag": "异常包裹",
            "k": "",
            "v": res.data,
            "overdue": null,
            "link": "https://logisic.rakumart.cn/#/businessAbnormalParcel"
          }
        )
      })
      if (this.y_id == '13' || this.y_id == '14' || this.y_id == '15' || this.y_id == '16' || this.y_id == '1196') {
        this.$api.overtimeStatistics({ y_id: this.y_id }).then(res => {
          this.tableData[2].row[3].list.push(
            {
              "tag": "超时物流部长待处理数量",
              "k": "",
              "v": res.data,
              "overdue": null,
              "link": "https://logisic.rakumart.cn/#/logisticsFollowUpExamine"
            }
          )
        })
      }

      this.$api.pickUpStatistics({ y_id: this.y_id }).then(res => {
        this.tableData[2].row[3].list.push(
          {
            "tag": "待取件数量",
            "k": "",
            "v": res.data,
            "overdue": null,
            "link": "https://logisic.rakumart.cn/#/businessUnclaimedItem"
          }
        )
      })
      this.$api.listNumUnConfirm().then(res => {
        this.tableData[1].row[4].list.push(
          {
            "tag": "评价待确认",
            "k": "",
            "v": res.data.count,
            "overdue": null,
            "link": "customerEvaluation"
          }
        )

      })

    },
    // 跳转
    link(link) {
      if (link.indexOf('https') != -1) {
        window.open(link, "_blank");
      } else {
        window.open('#/' + link, "_blank");
      }

    },
    //跳转紧急
    overdueLink(link) {
      let href = ''
      if (link.indexOf('?') === -1) {
        href = '#/' + link + '?overdue=1'
      } else {
        href = '#/' + link + '&overdue=1'
      }
      window.open(href, "_blank");
    }
  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-select {
  width: 320px;

  .el-input__inner {
    height: 50px;
  }
}

.list {
  display: flex;

  .row {
    flex: 1;
    margin-right: 24px;

    &:nth-last-child(1) {
      margin: 0;
    }

    .type {
      padding: 24px;
      border: 1px solid #ccc;
      border-radius: 8px;
      margin-top: 24px;
      background-color: #fff;

      .head {
        height: 24px;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 24px;
        margin-bottom: 22px;
        display: flex;

        span {
          margin-right: 12px;
          height: 24px;
          width: 4px;
          border-radius: 2px;
        }
      }

      .item {
        margin-top: 12px;
        padding: 12px 17px 12px 12px;
        background-color: pink;
        border-radius: 8px;
        display: flex;
        line-height: 32px;
        position: relative;
        cursor: pointer;

        .num {
          padding: 0 5px;
          min-width: 22px;
          height: 32px;
          background: #FF7364;
          border-radius: 4px;
          text-align: center;
          font-weight: bold;
          color: #fff;
          font-size: 16px;
          margin-right: 15px;
        }

        .name {
          font-size: 16px;
        }

        .exigency {
          position: absolute;
          top: 12px;
          right: 17px;
          font-size: 16px;
          color: #FF7364;
          font-weight: bold;
        }
      }
    }
  }
}
</style>